export const comments_5618950 = {"data":{"data":[],"links":{}}}